const data_program = [
    {
        id : "1",
        title : "Beasiswa Al-Qur'an",
        desc : "Beasiswa yang diberikan kepada para penghafal Al-Qur'an mulai dari tingkat SDS1"
    },
    {
        id : "2",
        title : "Beasiswa Kader Bangsa",
        desc : "Beasiswa diberikan kepada warga negara berupa jenjang pendidikan S2-S3, yang diharapkan dengan ilmunya bisa membangun bangsa."
    },
    {
        id : "3",
        title : "Beasiswa Prestasi",
        desc : "Beasiswa yang diberikan kepada warga negara tingkat SMP-S1, dilihat dari prestasi akademik"
    },
    {
        id : "4",
        title : "Beasiswa Dhuafa",
        desc : "Beasiswa diberikan kepada anak orang miskin dan dhuafa untuk melanjutkan pendidikan dari tingkat SD-SLTA."
    }
];

export default data_program;